import { Banner } from '@spotify-internal/encore-web';
import { FeatureFlagged } from '@spotify/confidence-flag-evaluation-react';
import { OnboardingV1ManagedDataWarehouseProvisioningState as ProvisioningState } from '@spotify/confidence-graphql';

import { useConfidenceCloudProvisioning } from '../../hooks/useConfidenceCloudProvisioning';
import { useConfidenceCloudStatus } from '../../hooks/useConfidenceCloudStatus';

import styles from './DemoDataSetupBanner.module.css';

export const DemoDataSetupBanner = () => {
  const { isConfidenceCloud } = useConfidenceCloudStatus();
  const { state, demoDataPending } = useConfidenceCloudProvisioning({
    skip: !isConfidenceCloud,
  });

  const settingUp = state === ProvisioningState.Creating || demoDataPending;

  if (!isConfidenceCloud || !settingUp) {
    return null;
  }

  return (
    <FeatureFlagged with="demo-data-setup">
      <Banner
        contextual
        colorSet="announcementSubdued"
        className={styles.banner}
      >
        Your demo data is being set up and will appear here shortly.
      </Banner>
    </FeatureFlagged>
  );
};
